/**
 * Calculates the number of days in a given month and year.
 *
 * @param {number|string} month - The month for which to get the number of days.
 * One-indexed, so January is 1 and December is 12. Can be a string or a number.
 * @param {number|string} [year=new Date().getFullYear()] - The year for which to get the number of days. Defaults to the current year if not provided.
 * @returns {number} The number of days in the specified month and year.
 */
export const getDaysInMonth = (month, year = new Date().getFullYear()) => {
    // If any parameter underflows, it "borrows" from the higher positions.
    // For example, new Date(2020, 5, 0) will return May 31st, 2020.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#parameters
    return new Date(year, month, 0).getDate()
}

/**
 * Checks if the given date is in the past.
 *
 * @param {string} dateString - The date to check in ISO format (YYYY-MM-DD).
 * @returns {boolean} - Returns true if the date is in the past, otherwise false.
 */
export const isPastDate = (value) => {
    const dateToCheck = new Date(value)
    const today = new Date()
    return dateToCheck < today
}
